/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Bright_Hawk_GlideInputs */

const en_keen_bright_hawk_glide = /** @type {(inputs: Keen_Bright_Hawk_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entire Organization`)
};

const de_keen_bright_hawk_glide = /** @type {(inputs: Keen_Bright_Hawk_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Organisation`)
};

/**
* | output |
* | --- |
* | "Entire Organization" |
*
* @param {Keen_Bright_Hawk_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_bright_hawk_glide = /** @type {((inputs?: Keen_Bright_Hawk_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Bright_Hawk_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_bright_hawk_glide(inputs)
	return de_keen_bright_hawk_glide(inputs)
});